import { LAYOUT_CONFIGS } from '../config/constants';

const useConfig = () => {
  const hosts = window.location.host.split('.');
  return LAYOUT_CONFIGS[hosts[0]] || LAYOUT_CONFIGS.default;
};

export default useConfig;
